import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatMenu, MatMenuContent, MatMenuTrigger } from '@angular/material/menu';
import { MatTooltip } from '@angular/material/tooltip';
import { connectState } from '@examdojo/angular/util';
import { ButtonComponent } from '@examdojo/core/button';
import { ExamdojoWindowFeature, FeatureFlagService } from '@examdojo/core/feature-flag';
import { IconComponent } from '@examdojo/core/icon';
import { keys } from '@examdojo/util/object-utils';
import { IonToggle } from '@ionic/angular/standalone';
import { map } from 'rxjs';

@Component({
  selector: 'dojo-feature-flag-toggle-menu',
  imports: [MatMenu, MatMenuContent, MatMenuTrigger, MatTooltip, ButtonComponent, IonToggle, IconComponent],
  templateUrl: './feature-flag-toggle-menu.component.html',
  styleUrls: ['./feature-flag-toggle-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FeatureFlagToggleMenuComponent {
  constructor(private readonly featureFlagService: FeatureFlagService) {}

  readonly state = connectState({
    featureFlags: this.featureFlagService.selectAll().pipe(
      map((allFlags) =>
        keys(allFlags)
          .filter((key) => typeof allFlags[key] === 'boolean')
          .map((key) => ({
            key,
            value: allFlags[key] as boolean,
          }))
          .sort((a, b) => a.key.localeCompare(b.key)),
      ),
    ),
  });

  onFeatureFlagToggle(flag: string, event: Event) {
    const checked = (event as CustomEvent).detail.checked;
    const examDojoWindow = window as typeof window & { examdojo: { feature: ExamdojoWindowFeature } };
    if (checked) {
      examDojoWindow.examdojo.feature.enable(flag);
    } else {
      examDojoWindow.examdojo.feature.disable(flag);
    }
  }
}
